import { render, staticRenderFns } from "./pixel.vue?vue&type=template&id=633daada"
import script from "./pixel.vue?vue&type=script&lang=js"
export * from "./pixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports